import { isAxiosError } from 'axios';
import { ApiErrorResponse } from './types';

/** 是否為後端 API 錯誤 */
export function isApiError(error: unknown) {
  if (!isAxiosError<ApiErrorResponse>(error)) {
    return false;
  }

  if (!error.response) {
    return false;
  }

  if (!error.response.data) {
    return false;
  }

  if (!error.response.data.code) {
    return false;
  }

  return true;
}
